import { FLOWS_PRODUCTS_PATH } from '@flows/src/FlowsProductsRouter';
import { useLocale } from '../../../../../i18n';
import useAuth from '../../../../app/src/features/authentication/hooks/useAuth';
import { getFlowInfo } from '../../../../flows/src/api/getFlowInfo';
import useFlowsInitNew from '../../../../flows/src/hooks/init/useFlowsInitNew';
import useFlowsResetState from '../../../../flows/src/hooks/useFlowsResetState';
import { FlowInfo } from '../../../../flows/src/types/FlowsTypes';

export interface AnvaFlowProduct {
  id: string;
  coverages: string[];
}

const useStartAnvaFlow = () => {
  const { initFlow } = useFlowsInitNew();
  const { userLang } = useLocale();
  const { campaign } = useAuth();
  const { reset } = useFlowsResetState();

  const getOutputUrl = (flowInfo: FlowInfo) => {
    if (flowInfo.type === 'anva') {
      return `${FLOWS_PRODUCTS_PATH}/${flowInfo.id}/overview`;
    }
    return `/sales-conversation/default/finalize`;
  };

  return async ({
    flowId,
    uuid,
    inputUrl,
    partyId,
    quoteId,
    quoteIds,
    anva_products,
  }: {
    flowId: string;
    anva_products: AnvaFlowProduct[];
    uuid?: string;
    inputUrl?: string;
    partyId?: string;
    quoteId?: string;
    quoteIds?: string[];
  }) => {
    reset();

    const flowInfo = await getFlowInfo(flowId, { lang: userLang });

    await initFlow({
      flowId: flowId,
      payload: {
        party_id: partyId,
        quote_id: quoteId,
        quote_ids: quoteIds,
        previous_session_id: flowInfo.previous ? uuid : undefined,
        subject: campaign?.subjects?.length ? campaign.subjects : undefined,
        anva_products: anva_products,
      },
      inputUrl,
      outputUrl: getOutputUrl(flowInfo),
      sessionId: uuid,
      shouldComplete: false,
    });
  };
};

export default useStartAnvaFlow;
